export default __webpack_public_path__ + "images/019dc2554e128976db8206b4c7414a35.svg";